import { default as _91token_937VEZpVW1C4Meta } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/activate/[token].vue?macro=true";
import { default as indexRaw7hYtvdqMeta } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/index.vue?macro=true";
import { default as _91token_93j7aJG5iWr0Meta } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/password/reset/[token].vue?macro=true";
import { default as indexvNLP6lIbqpMeta } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/password/reset/index.vue?macro=true";
import { default as redirectjTjsCm00I7Meta } from "/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/redirect.vue?macro=true";
export default [
  {
    name: "activate-token",
    path: "/activate/:token()",
    component: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/activate/[token].vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password/reset/:token()",
    component: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/password/reset/[token].vue")
  },
  {
    name: "password-reset",
    path: "/password/reset",
    component: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/password/reset/index.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/var/www/sites/auth.ultrafedt.dk/releases/20251107195032/pages/redirect.vue")
  }
]